import { useMutation, useQuery } from '@tanstack/react-query';
import { Button, Col, Divider, Form, Input, Select, Space } from 'antd';
import React, { useState } from 'react';
import { MdDelete } from 'react-icons/md';
import { queryKeys } from '../../../services/react-query/queryKeys';
import {
  getAllServicesAndItem,
  getEncounterServicesAndItem,
  getItems,
} from '../../../network/Item';
import { PlusOutlined } from '@ant-design/icons';
import { getItemDetails } from '../../../network/materialRequest';
import ItemListEncounter from './ItemListEncounter';

const ListItem = React.memo(
  ({ t, form, index, field, remove, add, itemsList }) => {
    const handleQtyChange = (value) => {
      const qty = parseFloat(value) || 0;
      const rate = form.getFieldValue(['custom_item', index, 'rate']) || 0;
      const discount =
        form.getFieldValue(['custom_item', index, 'discount_amount']) || 0;
      const amount = qty * (rate - discount);

      form.setFieldsValue({
        custom_item: form
          .getFieldValue('custom_item')
          .map((item, i) => (i === index ? { ...item, qty, amount } : item)),
      });
    };
    const { mutate: onGetItemDetails, data: itemDetails } = useMutation({
      mutationFn: (itemName) => getItemDetails('Sales Invoice', itemName),
      onSuccess: (itemDetails) => {
        console.log(itemDetails, 'itemDetails');
        // const newDataSource = [...dataSource];
        // newDataSource[selectedIndex] = {
        //   ...newDataSource[selectedIndex],
        //   ...itemDetails?.message,
        //   warehouse:form.getFieldValue('set_warehouse')
        // };;
        // setDataSource(newDataSource);;
      },
      onError: (error) => {
        console.log(error, 'error');
      },
    });
    const handleDiscountChange = (value) => {
      const discount = parseFloat(value) || 0;
      const initialRate =
        form.getFieldValue(['custom_item', index, 'initialRate']) || 0;
      const rate = initialRate - discount;
      const qty = form.getFieldValue(['custom_item', index, 'qty']) || 0;
      const amount = qty * rate;

      form.setFieldsValue({
        custom_item: form
          .getFieldValue('custom_item')
          .map((item, i) =>
            i === index ? { ...item, discount, amount, rate } : item
          ),
      });
    };

    const handleRateChange = (value) => {
      const rate = parseFloat(value) || 0;
      const qty = form.getFieldValue(['custom_item', index, 'qty']) || 0;
      const discount =
        form.getFieldValue(['custom_item', index, 'discount_amount']) || 0;
      const amount = qty * (rate - discount);

      form.setFieldsValue({
        custom_item: form
          .getFieldValue('custom_item')
          .map((item, i) => (i === index ? { ...item, rate, amount } : item)),
      });
    };

    return (
      <Space
        key={field.key}
        style={{ display: 'flex', alignItems: 'center', width: '100%' }}
      >
        <Form.Item
          name={[field.name, 'item_code']}
          label={t.items}
          style={{ width: '100%', marginBottom: '0px' }}
          rules={[{ required: true }]}
        >
          <Select
            placeholder={t.items}
            style={{ width: '100%' }}
            showSearch
            optionFilterProp="children"
            popupMatchSelectWidth={false}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            onChange={(value, option) => {
              onGetItemDetails(value);
              form.setFieldsValue({
                custom_item: form.getFieldValue('custom_item').map((item, i) =>
                  i === index
                    ? {
                        ...item,
                        item_code: value,
                        initialRate: option?.data.rate,
                        rate: option?.data.rate,
                        qty: 1,
                        discount_amount: 0,
                        amount: option?.data.rate,
                      }
                    : item
                ),
              });
            }}
            options={itemsList?.message?.map((item) => ({
              value: item?.value,
              label: item?.value,
              data: { ...item },
            }))}
          />
        </Form.Item>
        <Form.Item
          name={[field.name, 'qty']}
          style={{ width: '100%', marginBottom: '0px' }}
          label={t.quantity}
        >
          <Input
            placeholder={t.quantity}
            style={{ width: '100%' }}
            type="number"
            onChange={(e) => handleQtyChange(e.target.value)}
            min={0}
          />
        </Form.Item>
        <Form.Item
          name={[field.name, 'discount_amount']}
          style={{ width: '100%', marginBottom: '0px' }}
          label={t.discountAmount}
        >
          <Input
            placeholder={t.discountAmount}
            style={{ width: '100%' }}
            type="number"
            onChange={(e) => handleDiscountChange(e.target.value)}
            min={0}
          />
        </Form.Item>
        <Form.Item
          name={[field.name, 'rate']}
          style={{ width: '100%', marginBottom: '0px' }}
          label={t.rate}
        >
          <Input
            placeholder={t.rate}
            style={{ width: '100%' }}
            type="number"
            onChange={(e) => handleRateChange(e.target.value)}
            min={0}
          />
        </Form.Item>
        <Form.Item
          name={[field.name, 'amount']}
          style={{ width: '100%', marginBottom: '0px' }}
          label={t.amount}
        >
          <Input
            placeholder={t.amount}
            style={{ width: '100%' }}
            type="number"
            min={0}
            readOnly
          />
        </Form.Item>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '15px',
            margin: '0 10px',
          }}
        >
          {remove && (
            <Button
              type="text"
              onClick={() => remove(field.name)}
              danger
              icon={<MdDelete color="red" />}
            />
          )}
          {add && (
            <Button
              type="text"
              onClick={() => add()}
              icon={<PlusOutlined color="#1890ff" />}
            />
          )}
        </div>
      </Space>
    );
  }
);

const EncounterItems = ({ t, form, dataSource, setDataSource }) => {
  const { data: itemsList } = useQuery({
    queryKey: [queryKeys.getAllServicesAndItem],
    queryFn: getEncounterServicesAndItem,
    keepPreviousData: true,
  });

  return (
    <>
      <Divider orientation="left">{t.items}</Divider>
      <Col span={24} className="items">
        {/* <Form.List name="custom_item" style={{ width: '100%' }}>
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => (
                <ListItem
                  key={field.key}
                  t={t}
                  form={form}
                  index={index}
                  field={field}
                  remove={fields.length > 1 ? remove : null}
                  add={add}
                  itemsList={itemsList}
                />
              ))}
            </>
          )}
        </Form.List> */}
        <ItemListEncounter
          t={t}
          form={form}
          setDataSource={setDataSource}
          dataSource={dataSource}
        />
      </Col>
    </>
  );
};

export default EncounterItems;
